/*
 * IRIS custom: on touch devices (mobile), holding a finger down on a
 * product card's image swaps it to the secondary/hover image — the same
 * image swap Dawn already does on desktop via :hover (only active at
 * min-width: 990px, see component-card.css), which never fires on touch
 * screens since there is no real hover. This adds a `.media--touch-active`
 * class on touchstart (removed on touchend/touchcancel) that a matching
 * CSS rule in custom-iris.css uses to trigger the same swap. Applies
 * sitewide (all collections, search, related products, etc.) since it's
 * attached once here via event delegation rather than per-card.
 */
(function () {
  if (window.irisTouchPreviewInit) return;
  window.irisTouchPreviewInit = true;

  function clearActive() {
    document.querySelectorAll('.media--touch-active').forEach(function (el) {
      el.classList.remove('media--touch-active');
    });
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var media = event.target.closest('.media--hover-effect');
      if (!media) return;
      clearActive();
      media.classList.add('media--touch-active');
    },
    { passive: true }
  );

  document.addEventListener('touchend', clearActive, { passive: true });
  document.addEventListener('touchcancel', clearActive, { passive: true });
})();
